// src/services/auth.ts

import {jwtDecode} from "jwt-decode";

export interface DecodedToken {
    roles: string[];
    username: string;
    id: number;
    name: string;
    scopes: string[];
    subscription_plans: string[];
    iat?: number; // issued at
    exp?: number; // expiration time
}

/**
 * Récupère et décode le token JWT stocké dans le localStorage.
 * Retourne null si le token est inexistant ou invalide.
 */
export function getUser(): DecodedToken | null {
    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }
    return jwtDecode(token) as DecodedToken;
}